"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleFE_LanguageLocale = exports.ModuleFE_LanguageLocale_Class = exports.dispatch_onLanguageLocaleChanged = void 0;
const frontend_1 = require("@nu-art/thunderstorm/frontend");
const v3_types_1 = require("@nu-art/thunderstorm/frontend/core/db-api-gen/v3_types");
const shared_1 = require("../shared");
exports.dispatch_onLanguageLocaleChanged = new v3_types_1.ThunderDispatcherV3('__onLanguageLocaleUpdated');
class ModuleFE_LanguageLocale_Class extends frontend_1.ModuleFE_v3_BaseApi {
    constructor() {
        super(shared_1.DBDef_LanguageLocale, exports.dispatch_onLanguageLocaleChanged);
        this._v1 = {
            '?': (0, frontend_1.apiWithBody)(shared_1.ApiDef_LanguageLocale._v1['?']),
            '??': (0, frontend_1.apiWithQuery)(shared_1.ApiDef_LanguageLocale._v1['??']),
        };
    }
}
exports.ModuleFE_LanguageLocale_Class = ModuleFE_LanguageLocale_Class;
exports.ModuleFE_LanguageLocale = new ModuleFE_LanguageLocale_Class();
